<template>
	<div>
		<navbar
			@reload="reload"
			:data="item"
			:user="user"
			:type="'edit'"
			:isAuth="isAuth">
		</navbar>

		<div v-if="item" class="row">
			<div class="col-md-12">
				<orders-datatable
					ref="datatable"
					@reload="reload"
					@reloadNavBar="reloadNavBar"
					:user="user"
					:isAuth="isAuth"
					:customer="item">
				</orders-datatable>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	import OrdersDatatable from '@/components/management/orders/views/Datatable.vue'
	import Navbar from './Navbar.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'orders-datatable': OrdersDatatable,
			'navbar': Navbar,
		},
		data () {
			return {
				item: null,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			reload() {
				this.getData()
			},
			reloadNavBar() {
				this.$http.get('admin/customers/' + this.$route.params.id)
				.then(response => {
					this.item = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			getData() {
				this.$http.get('admin/customers/' + this.$route.params.id)
				.then(response => {
					this.item = response.body
					this.$nextTick( () => this.$refs.datatable.reload())
				}).catch(function(response) {
					console.log(response)
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/customers/views/Orders.vue